import { useTranslation } from 'react-i18next';

import { IVehicle } from '../../../schema/Vehicle.ts';
import { Vehicle } from './Vehicle.tsx';

interface Props {
  vehicles: IVehicle[];
  groupName: 'IN_OPERATION' | 'PLANNED_OPERATION' | 'NO_OPERATION';
  totalCount: number;
  extraStyle?: string | '';
}

export function VehicleGroup(props: Readonly<Props>) {
  const { t } = useTranslation();
  const nameMapping = {
    IN_OPERATION: t('fleet.in-operation'),
    PLANNED_OPERATION: t('fleet.planned-operation'),
    NO_OPERATION: t('fleet.inactive'),
  };
  if (props.vehicles.length > 0) {
    return (
      <>
        <p className={`card-subtitle ${props.extraStyle}`}>
          {nameMapping[props.groupName]} {props.vehicles.length}/{props.totalCount}
        </p>
        {props.vehicles.map((vehicle: IVehicle) => (
          <Vehicle vehicle={vehicle} key={vehicle.id} groupName={props.groupName} />
        ))}
      </>
    );
  }
}
